/**
 * Chatbot Guide Utilisateur - Bouton flottant + chargement lazy du panneau
 * Le panneau (et la base de connaissance) ne sont chargés qu'à la première ouverture.
 */

import { lazy, Suspense, useState } from 'react';
import type { ChatbotContext } from '../../chatbot/types';
import { loadChatOpen, saveChatOpen } from './chatStore';
import './ChatWidget.css';

const ChatWidget = lazy(() => import('./ChatWidget'));

interface ChatWidgetLauncherProps {
  context: ChatbotContext;
}

export function ChatWidgetLauncher({ context }: ChatWidgetLauncherProps) {
  // Le panneau rouvre automatiquement après une navigation (chaque page remonte le layout)
  const [open, setOpen] = useState(loadChatOpen());
  const [loaded, setLoaded] = useState(loadChatOpen());

  const setOpenPersisted = (value: boolean) => {
    saveChatOpen(value);
    setOpen(value);
  };

  const handleToggle = () => {
    if (!loaded) setLoaded(true);
    setOpenPersisted(!open);
  };

  return (
    <div className="chatbot-root">
      {loaded && (
        <Suspense fallback={null}>
          {open && <ChatWidget context={context} onClose={() => setOpenPersisted(false)} />}
        </Suspense>
      )}
      <button
        className="chatbot-launcher"
        onClick={handleToggle}
        aria-label={open ? 'Fermer le guide' : 'Ouvrir le guide'}
        title="Guide de la plateforme"
      >
        {open ? '✕' : '💬'}
      </button>
    </div>
  );
}
